export default __webpack_public_path__ + "static/media/item_1@2x.043ea69b.webp";